<section (click)="onOpen()" (keydown)="onKeydown($event)" role="button" tabindex="0">
	<mat-icon class="material-symbols-outlined" aria-hidden="true">article</mat-icon>
	<p>{{ document().name }}</p>
</section>
